import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Transition } from '@headlessui/react';
import IconBirdLogo from 'components/icons/iconBirdLogo';
import closeIcon from 'assets/icons/ico-close.svg';
import JBImage from 'components/essentials/JBImage';
import notificationBannerHelper from './utils';
const NotificationBannerSkeleton = t0 => {
  const $ = _c(38);
  const {
    title,
    icon,
    body,
    onClose,
    modifier,
    keepOpenOnMouseEnter: t1
  } = t0;
  const keepOpenOnMouseEnter = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== icon) {
    t2 = icon || <IconBirdLogo color="#27919C" style={{
      transform: "scale3d(calc(26/16), calc(19/11), 1)",
      margin: 0
    }} />;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconHTML = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("w-full md:w-[457px] cursor-auto border border-solid [border-color:#dbf0f0] rounded bg-[#f4f9fa] fixed flex items-start z-[1009] px-5 py-[1.375rem]");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] !== keepOpenOnMouseEnter) {
    t4 = () => {
      if (keepOpenOnMouseEnter) {
        notificationBannerHelper.removeTimeout();
      }
    };
    t5 = () => {
      if (keepOpenOnMouseEnter) {
        notificationBannerHelper.hideMsgWithTimeout();
      }
    };
    $[3] = keepOpenOnMouseEnter;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = modifier !== "second";
  const t7 = modifier === "second";
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = classNames("opacity-100", "top-auto left-0 right-0", "md:left-auto md:bottom-auto md:right-[4.25rem]", {
      "md:top-[7.125rem] bottom-[5px]": t6,
      "md:top-[16.125rem] bottom-40": t7
    });
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = modifier !== "second";
  const t10 = modifier === "second";
  let t11;
  if ($[9] !== t10 || $[10] !== t9) {
    t11 = classNames("transition-all duration-500", "top-auto left-0 right-0", "md:left-auto md:bottom-auto", {
      "md:top-[7.125rem] bottom-[5px]": t9,
      "md:top-[16.125rem] bottom-40": t10
    });
    $[9] = t10;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = modifier !== "second";
  const t13 = modifier === "second";
  let t14;
  if ($[12] !== t12 || $[13] !== t13) {
    t14 = classNames("opacity-100", "md:right-[4.25rem]", {
      "bottom-[5px]": t12,
      "bottom-40": t13
    });
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== iconHTML) {
    t15 = <div className="[&_span]:![border-bottom:none]">{iconHTML}</div>;
    $[15] = iconHTML;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== title) {
    t16 = title && <div className="font-bold text-base text-gray">{title}</div>;
    $[17] = title;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== body) {
    t17 = body && <div className="text-base text-gray items-center flex [&_a]:text-base [&_a]:text-brand [&_a]:no-underline">{body}</div>;
    $[19] = body;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t16 || $[22] !== t17) {
    t18 = <div className="!text-gray ml-4">{t16}{t17}</div>;
    $[21] = t16;
    $[22] = t17;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== onClose) {
    t19 = (...t20) => {
      const args = t20;
      notificationBannerHelper.hideMsg();
      if (onClose) {
        onClose(...args);
      }
    };
    $[24] = onClose;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <JBImage src={closeIcon} width={18} />;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t19) {
    t21 = <button type="button" className="[background:none] border-0 absolute right-4 top-[1.125rem] w-[12.25px] cursor-pointer [&_img]:m-0 [&_img]:text-gray" onClick={t19}>{t20}</button>;
    $[27] = t19;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t11 || $[30] !== t14 || $[31] !== t15 || $[32] !== t18 || $[33] !== t21 || $[34] !== t4 || $[35] !== t5 || $[36] !== t8) {
    t22 = <Transition.Child className={t3} onMouseEnter={t4} onMouseLeave={t5} appear={true} enter="transition-opacity duration-150" enterFrom="opacity-0" enterTo={t8} leave={t11} leaveFrom={t14} leaveTo="opacity-0 md:right-[-457px] bottom-[-500px]">{t15}{t18}{t21}</Transition.Child>;
    $[29] = t11;
    $[30] = t14;
    $[31] = t15;
    $[32] = t18;
    $[33] = t21;
    $[34] = t4;
    $[35] = t5;
    $[36] = t8;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  return t22;
};
NotificationBannerSkeleton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  body: PropTypes.node,
  onClose: PropTypes.func,
  modifier: PropTypes.oneOf(['second', 'top']),
  keepOpenOnMouseEnter: PropTypes.bool
};
export default NotificationBannerSkeleton;